import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

// Mirrors auth.guard.ts but omits the hasActiveAccess() check so /billing can be reached
// by users whose access has lapsed without causing an infinite redirect loop.
function evaluateAuthOnly(
  auth: AuthService,
  router: Router
): boolean | ReturnType<typeof router.createUrlTree> {
  const user = auth.currentUser();

  if (!user) return router.createUrlTree(['/auth']);
  if (!user.emailVerified) return router.createUrlTree(['/auth/verify-email']);
  if (!auth.hasRole()) return router.createUrlTree(['/onboarding']);

  return true;
}

export const requiresAuthGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.ready()) {
    return evaluateAuthOnly(auth, router);
  }

  return toObservable(auth.ready).pipe(
    filter((ready) => ready),
    take(1),
    map(() => evaluateAuthOnly(auth, router))
  );
};
